export const AUTH = 'auth';
export const SITE = 'site';
